import axios from 'axios';

const BASE_URL = `https://api.trustcirclereferral.com/languages`;

const getLanguages = async () => axios.get(`${BASE_URL}`);

export default getLanguages;
